<div class="page-content">
  <!--mobile view-->
  <div class="ontario-row ontario-padding-bottom-8-! mobile-view">
    <div class="ontario-column ontario-small-12">
      <a [routerLink]="currentLang=='en' ? '/safety-and-prevention/home':'/fr/safety-and-prevention/home'"
        target="_blank">
        {{'LearnerCertificateStatus.VisitPreventionPage' | translate }}
      </a>
    </div>
    <div class="ontario-column ontario-small-12 ">
      <h1 class="page-title">{{'LearnerCertificateStatus.TrainingCertificateStatus' | translate}}</h1>
    </div>
    @if (!roc || !learner || learner.Id === '00000000-0000-0000-0000-000000000000') {
      <div class="ontario-column ontario-small-12 ontario-large-9">
        <div class="ontario-row ontario-padding-top-16-!">
          <app-alert-banner [bannerType]="'critical'"
          [bannerText]="translateService.instant('LearnerCertificateStatus.NoRecordFound')"></app-alert-banner>
        </div>
      </div>
    }
    @if (roc && learner) {
      <div class="ontario-column ontario-small-12 ontario-large-9">
        <div class="roc-details  ontario-padding-bottom-8-!" [class.solid-border-bottom]="true">
          <div class="header-box ontario-row ">
            <div class="ontario-column ontario-small-8 program-name">{{currentLang == 'fr' ? roc.ProgramNameFr :
            roc.ProgramName}}</div>
            <div class="ontario-column reduced-padding ontario-small-4">
              <div class="roc-status-bar" [class.status-valid]="roc.Status==1 || roc.Status==2"
                [class.status-in-progress]="roc.Status == 3" [class.status-invalid]="roc.Status>3">
                {{'ROCStatus.' + roc.Status | translate}}
              </div>
            </div>
          </div>
          @if (learnerProfileWasMerged) {
            <div class="ontario-row ontario-padding-top-16-!">
              <app-alert-banner [bannerType]="'warning'"
              [bannerText]="translateService.instant('LearnerCertificateStatus.LearnerMergedBanner').replaceAll('{0}', learner.MergedOn|utcToLocalDateTime).replace('{1}', learner.PreviousWorkerDisplayId ? utilsService.GetSubstring(learner.PreviousWorkerDisplayId,10) : '').replace('{2}', learner.WorkerDisplayId ? utilsService.GetSubstring(learner.WorkerDisplayId,10) : '')"></app-alert-banner>
            </div>
          }
          <div class="ontario-row">
            <div
              class="ontario-column ontario-small-12 ontario-medium-12 ontario-padding-top-24-! ontario-padding-bottom-24-!">
              <label>{{'LearnerCertificateStatus.LearnerName' | translate}}</label>
              <span>{{learner.FirstName}} {{learner.LastName}}</span>
            </div>
            <div class="ontario-column ontario-small-12 ontario-medium-12 ontario-padding-bottom-24-!">
              <label>{{'TrainingEligibility.LearnerId' | translate}}</label>
              <span>{{learner.WorkerDisplayId ? utilsService.GetSubstring(learner.WorkerDisplayId,10) : ''}}</span>
            </div>
            <div class="ontario-column ontario-small-12 ontario-medium-12 ontario-padding-bottom-24-!">
              <label>{{'LearnerCertificateStatus.TrainingStandards' | translate}}</label>
              <span>{{currentLang == 'fr' ? roc.ProgramNameFr : roc.ProgramName}}</span>
            </div>
            <div class="ontario-column ontario-small-12 ontario-medium-12 ontario-padding-bottom-24-!">
              <label>{{'LearnerCertificateStatus.CompletionDate' | translate}}</label>
              <span>{{roc.CompletedDate| utcToLocalDateTime : 'MMM dd, yyyy' : langCode}}</span>
            </div>
            <div class="ontario-column ontario-small-12 ontario-medium-12 ontario-padding-bottom-24-!">
              <label>{{'Worker.ValidUntil' | translate}}</label>
              <span>{{roc.ExpirationDate| utcToLocalDateTime : 'MMM dd, yyyy' : langCode}}</span>
            </div>
          </div>
        </div>
      </div>
    }
    <div class="ontario-column ontario-small-12 ontario-large-3 ontario-padding-top-24-! ontario-padding-bottom-24-!">
      <div class="grey-box-mobile border-bottom border-bottom-margin">
        <app-page-content-loop [pageContents]="sideBarContents"></app-page-content-loop>
      </div>
      <div class="ontario-padding-top-24-! border-bottom border-bottom-margin">
      </div>
    </div>
  </div>

  <!--desktop view-->
  <div class="ontario-row ontario-padding-bottom-8-! desktop-view">
    <div class="ontario-column ontario-small-12 ">
      <a [routerLink]="currentLang=='en' ? '/safety-and-prevention/home':'/fr/safety-and-prevention/home'"
        target="_blank">
        {{'LearnerCertificateStatus.VisitPreventionPage' | translate }}
      </a>
    </div>
    <div class="ontario-column ontario-small-12 ">
      <h1 class="page-title">{{'LearnerCertificateStatus.TrainingCertificateStatus' | translate}}</h1>
    </div>
    @if (!roc || !learner || learner.Id === '00000000-0000-0000-0000-000000000000') {
      <div class="ontario-column ontario-small-12 ontario-large-9">
        <div class="ontario-row ontario-padding-top-16-!">
          <app-alert-banner [bannerType]="'critical'"
          [bannerText]="translateService.instant('LearnerCertificateStatus.NoRecordFound')"></app-alert-banner>
        </div>
      </div>
    }
    @if (roc && learner) {
      <div class="ontario-column ontario-small-12 ontario-large-9">
        <div class="roc-card">
          <div class="roc-column program-name">{{currentLang == 'fr' ? roc.ProgramNameFr : roc.ProgramName}}</div>
          <div class="roc-column roc-status-bar" [class.status-valid]="roc.Status==1 || roc.Status==2"
            [class.status-in-progress]="roc.Status == 3" [class.status-invalid]="roc.Status>3">
            {{'ROCStatus.' + roc.Status | translate}}
          </div>
        </div>
        <div class="roc-details  ontario-padding-bottom-8-!" [class.solid-border-bottom]="true">
          @if (learnerProfileWasMerged) {
            <div class="ontario-row ontario-padding-top-16-!">
              <app-alert-banner [bannerType]="'warning'"
              [bannerText]="translateService.instant('LearnerCertificateStatus.LearnerMergedBanner').replaceAll('{0}', learner.MergedOn|utcToLocalDateTime).replace('{1}', learner.PreviousWorkerDisplayId ? utilsService.GetSubstring(learner.PreviousWorkerDisplayId,10) : '').replace('{2}', learner.WorkerDisplayId ? utilsService.GetSubstring(learner.WorkerDisplayId,10) : '')"></app-alert-banner>
            </div>
          }
          <div class="ontario-row">
            <div
              class="ontario-column ontario-small-12 ontario-medium-12 ontario-padding-top-24-! ontario-padding-bottom-24-!">
              <label>{{'LearnerCertificateStatus.LearnerName' | translate}}</label>
              <span>{{learner.FirstName}} {{learner.LastName}}</span>
            </div>
            <div class="ontario-column ontario-small-12 ontario-medium-12 ontario-padding-bottom-24-!">
              <label>{{'TrainingEligibility.LearnerId' | translate}}</label>
              <span>{{learner.WorkerDisplayId ? utilsService.GetSubstring(learner.WorkerDisplayId,10) : ''}}</span>
            </div>
            <div class="ontario-column ontario-small-12 ontario-medium-12 ontario-padding-bottom-24-!">
              <label>{{'LearnerCertificateStatus.TrainingStandards' | translate}}</label>
              <span>{{currentLang == 'fr' ? roc.ProgramNameFr : roc.ProgramName}}</span>
            </div>
            <div class="ontario-column ontario-small-12 ontario-medium-12 ontario-padding-bottom-24-!">
              <label>{{'LearnerCertificateStatus.CompletionDate' | translate}}</label>
              <span>{{roc.CompletedDate| utcToLocalDateTime : 'MMM dd, yyyy' : langCode}}</span>
            </div>
            <div class="ontario-column ontario-small-12 ontario-medium-12 ontario-padding-bottom-24-!">
              <label>{{'Worker.ValidUntil' | translate}}</label>
              <span>{{roc.ExpirationDate| utcToLocalDateTime : 'MMM dd, yyyy' : langCode}}</span>
            </div>
          </div>
        </div>
      </div>
    }
    <div class="ontario-column ontario-small-12 ontario-large-3">
      <div class="grey-box border-bottom border-bottom-margin">
        <app-page-content-loop [pageContents]="sideBarContents"></app-page-content-loop>
      </div>
    </div>
  </div>

</div>